module.exports = __webpack_public_path__ + "img/downloadApp-cover.1edeb39b.png";